var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gdpr-export", class: _vm.customClass },
    [
      _vm.description !== undefined
        ? [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.description) } }),
            _c("hr"),
          ]
        : _vm._e(),
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.downloadDescription) } }),
      _vm.gotPsychologistJournals === true
        ? _c(
            "b-card",
            [
              _c("b-card-text", {
                domProps: { innerHTML: _vm._s(_vm.pSYJournalInfo) },
              }),
            ],
            1
          )
        : void 0,
      _c(
        "span",
        { staticClass: "mt-4 d-flex align-items-center" },
        [
          _c(
            "b-overlay",
            {
              staticClass: "d-inline-block",
              attrs: {
                show: _vm.isDownloading === true,
                opacity: "0.6",
                "spinner-small": "",
              },
            },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    disabled:
                      _vm.isDownloading === true || _vm.isProxy === true,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.getGdprData()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.downloadButtonText))]
              ),
            ],
            1
          ),
          _vm.isDownloading === true
            ? _c("span", { staticClass: "ml-2" }, [
                _vm._v("..." + _vm._s(_vm.loadingText)),
              ])
            : _vm._e(),
          _vm.isProxy === undefined || _vm.isProxy === true
            ? _c("span", { staticClass: "ml-2" }, [
                _vm._v(_vm._s(_vm.proxyWarning)),
              ])
            : _vm._e(),
          _vm.downloadError === true
            ? _c(
                "span",
                { staticClass: "ml-2" },
                [
                  _c("b-icon", {
                    attrs: { icon: "x", variant: "danger", scale: "2" },
                  }),
                  _vm._v(" error"),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }